import MQTT from '@/utils/network/mqtt'
import { mqttUrl } from '@/utils/base'
import { getMsgTopic } from '@/api/modules/base'
import EventBus from '@/utils/eventBus'
/**
 * 统一订阅质疑/通知消息
 * @param {string} channelCode - 渠道编号
 * @param {object} [handlers] - 自定义回调
 * @param {function} [handlers.onMessage] - 收到消息时触发（收到 EventBus 之前）
 * @returns {function} unsubscribe 清理函数
 */
export async function subscribeNotice(channelCode, handlers = {}) {
  MQTT.disconnect()
  const res = await getMsgTopic(channelCode)
  if (res.code !== 200 || !res.data) return () => {}

  const topic = res.data

  const num = Math.floor(Math.random() * 1000000000000000000)
  MQTT.connect(mqttUrl, {
    username: '',
    password: '',
    clientId: num,
    keepalive: 60,
    clean: true
  })

  MQTT.on('connect', () => {
    console.log('[MQTT] 监听连接成功')
  })

  const messageHandler = (rawMessage) => {
    let msgObj = null
    try {
      msgObj = typeof rawMessage === 'string' ? JSON.parse(rawMessage) : rawMessage
    } catch (e) {
      msgObj = rawMessage
    }
    console.log('[MQTT] 收到消息:', msgObj)
    if (typeof handlers.onMessage === 'function') {
      try { handlers.onMessage(msgObj) } catch (e) { console.error(e) }
    }
    EventBus.$emit('question-challenge-received', msgObj)
    EventBus.storeMqttMessage(msgObj)
  }

  MQTT.subscribe(topic, messageHandler, { qos: 2 })

  MQTT.on('error', (err) => {
    console.error('[MQTT] 链接失败', err)
  })

  return function unsubscribe() {
    try { MQTT.unsubscribe(topic, messageHandler) } catch (e) {}
  }
}
